module.exports = __webpack_public_path__ + "static/media/MAP.1cb0c6c6.png";